import { render } from "./ProductView.vue?vue&type=template&id=35747eab"
import script from "./ProductView.vue?vue&type=script&lang=js"
export * from "./ProductView.vue?vue&type=script&lang=js"

import "./ProductView.vue?vue&type=style&index=0&id=35747eab&lang=css"
script.render = render

export default script